import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PaymentFailPromotion() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // 실패 정보 로깅 (필요시)
    const code = searchParams.get("code");
    const message = searchParams.get("message");

    if (
      code === "PAY_PROCESS_CANCELED" ||
      message === "사용자가 결제를 취소하였습니다"
    ) {
      // ignore
    } else {
      if (message) {
        alert(message);
      }
    }

    // 파라미터 없이 결제 페이지로 리다이렉트
    navigate("/promotion-onboarding/payment/1", { replace: true });
  }, [searchParams, navigate]);

  return null;
}
